/* istanbul ignore next */
const ACTIONS = {
    GET_CURRENCIES_SUCCESS: 'GET_CURRENCIES_SUCCESS',
    GET_CURRENCIES: 'GET_CURRENCIES',
    CURRENCY_SERVICE_ERROR: 'CURRENCY_SERVICE_ERROR',
    SET_CURRENCY: 'SET_CURRENCY',
    UPDATE_CURRENCY: 'UPDATE_CURRENCY',
    SET_CURRENCY_CHANGE_ERROR: 'SET_CURRENCY_CHANGE_ERROR',
    ENABLE_CONTINUE_BUTTON: 'ENABLE_CONTINUE_BUTTON',
    PRE_POPULATE_LOCAL_STATE_CURRENCY: 'PRE_POPULATE_LOCAL_STATE_CURRENCY',
    GET_SUPPORTED_CURRENCIES: 'GET_SUPPORTED_CURRENCIES',
    GET_SUPPORTED_CURRENCIES_SUCCESS: 'GET_SUPPORTED_CURRENCIES_SUCCESS',
    GET_SITE_DETAILS: 'GET_SITE_DETAILS',
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    getCurrencies() {
        return {
            type: ACTIONS.GET_CURRENCIES
        };
    },

    getCurrenciesSuccess(currencyMetadata) {
        return {
            type: ACTIONS.GET_CURRENCIES_SUCCESS,
            payload: {
                currencyMetadata
            }
        };
    },

    currencyServiceError(errorKey) {
        return {
            type: ACTIONS.CURRENCY_SERVICE_ERROR,
            payload: {
                errorKey
            }
        };
    },

    getSupportedCurrencies(preferredLocale) {
        return {
            type: ACTIONS.GET_SUPPORTED_CURRENCIES,
            payload: {
                preferredLocale
            }
        }
    },

    getSupportedCurrenciesSuccess(supportedCurrencies) {
        return {
            type: ACTIONS.GET_SUPPORTED_CURRENCIES_SUCCESS,
            payload: {
                supportedCurrencies
            }
        };
    },

    setCurrency(currency) {
        return {
            type: ACTIONS.SET_CURRENCY,
            payload: {
                currency
            }
        };
    },

    updateCurrency(currency, userInfo) {
        return {
            type: ACTIONS.UPDATE_CURRENCY,
            payload: {
                currency,
                userInfo
            }
        };
    },

    setCurrencyChangeError(errorKey) {
        return {
            type: ACTIONS.SET_CURRENCY_CHANGE_ERROR,
            payload: {
                errorKey
            }
        };
    },

    enableContinueButton(enable) {
        return {
            type: ACTIONS.ENABLE_CONTINUE_BUTTON,
            payload: {
                enable
            }
        };
    },

    prePopulateLocalState(publicUuid) {
        return {
            type: ACTIONS.PRE_POPULATE_LOCAL_STATE_CURRENCY,
            payload: {
                publicUuid
            }
        };
    },

    getSiteDetails(countryCode) {
        return {
            type: ACTIONS.GET_SITE_DETAILS,
            payload: {
                countryCode
            }
        };
    },
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
